module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/cloudy-0683dc8dce7a6985ee6616d6dc7d8dfd.svg";